import { writable } from 'svelte/store'

export type Dimension = {
	width: number
	height: number
}

const dim: Dimension = { width: 0, height: 0 }

export const dimensions = writable({
	screen: { ...dim },
	divRoot: { ...dim },
	divInvoice: { ...dim },
	divMenu: { ...dim }
	//,
	//divListInvoices: { ...dim }
})
